import type { PaymentPlatform } from '@forest/paywall-core'

const params = new URLSearchParams(window.location.search)

export const appVersion = params.get('app_version') ?? '0.0.0'

export const language = params.get('language') ?? 'en'

function isPaymentPlatform(value: string | null): value is PaymentPlatform {
  return (
    value === 'ios' ||
    value === 'googleplay_android' ||
    value === 'china_android'
  )
}

/**
 * Read at bootstrap, not at import, so it reflects the launch URL. `null`
 * when missing or unknown.
 */
export function readPlatform(): PaymentPlatform | null {
  const platform = new URLSearchParams(window.location.search).get('platform')
  return isPaymentPlatform(platform) ? platform : null
}
